import { render } from "./InformationDialogue.vue?vue&type=template&id=43ff1d24"
import script from "./InformationDialogue.vue?vue&type=script&lang=js"
export * from "./InformationDialogue.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__